const resource = {
  localeId: 'en-GB',
  extendsLocale: undefined,
  resources: {}
};

export default resource;
